import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../../contants/APP_ROUTES';
import { DateHelper } from '../../helpers/DateHelper';
import { DataSummary } from '../../models/reports/dataSummary';
import { ReportService } from '../../services/report.service';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
	dataSummary: DataSummary = new DataSummary();
	dateNow: Date;

	constructor(
		private _reportService: ReportService,
		private _router: Router
	) { }

	ngOnInit() {
		this._reportService.getSummary().subscribe(
			result => {
				if(result != undefined){
					this.dataSummary = result;
				}
			}
		);

		this.dateNow = new Date();
	}


	isNearingDue(dateString: string){
		let date = new Date(dateString);
		let difference = DateHelper.getDateDifferenceInDays(this.dateNow, date);
		if(difference < 7){
			return true;
		}

		return false;
	}

	goToDailyTrip(){
		this._router.navigate([APP_ROUTES.dailyTripList], {queryParams: {isDateNow: true}});
	}

	goToClient(id: number){
		this._router.navigate([APP_ROUTES.clientForm.replace('/:id', ''), id]);
	}

	goToPaymentsList(tripId: number){
		this._router.navigate([APP_ROUTES.tripPaymentList], {queryParams: {isDateNow: false, tripId: tripId}});
	}

	goToPayment(id: number){
		this._router.navigate([APP_ROUTES.tripPaymentForm.replace('/:id', ''), id]);
	}

	getTotalClientBalance(): number {
		let total = 0;
		this.dataSummary.clientBalances.forEach(x => total += x.totalRemainingBalance);
		return total;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts